import { Link } from "react-router-dom";

function NotFound() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white text-center px-4">
            <h1 className="text-6xl font-bold mb-4
                            md:text-8xl">404</h1>
            <p className="text-xl mb-6
                            md:text-2xl">Oops! Pagina non trovata.</p>
            <Link
                to="/"
                className="px-6 py-3 bg-white text-black rounded-md font-semibold hover:bg-gray-200 transition duration-300"
            >
                Torna alla home
            </Link>
        </div>
    );
}

export default NotFound;
